import * as React from "react";
import Panolens from "../panolens/panolens";

const usePanolens = (img: string | HTMLImageElement, opts) => {
  let panolens = React.useMemo(() => new Panolens(img, opts), []);

  return panolens;
};

export default usePanolens;
